// extracted by css-extract-rspack-plugin
export default {"confirm":"confirm-Vkyn73","confirmTitle":"confirmTitle-vjRFBa"};